
/**
 * x轴高亮显示刻度
 * @param opt option配置项
 * @param config isRealtime 是否realTime折线图
 * @returns
 */
import { ConfigType } from "@/pages/home/components/Chart/_config/interface";
export const xAxisHighLight = (opt, config: ConfigType = { isRealtime: false }) => {
  opt.tooltip.axisPointer = {
    z: 99,
    type: config.type,
    label: {
      show: true,
      // backgroundColor: 'transparent',
      backgroundColor: '#ffffff',
      fontSize: 10,
      color: '#262832',
      fontWeight: 700,
      formatter: (params: { value: any; }) => config.formatter ? config.formatter(params) : params.value
    },
    lineStyle: config?.lineStyle || {
      color: '#BBBDCB',
      width: 1,
      type: 'solid',
    },
  };
  // opt.tooltip.axisPointer.lineStyle.width = 0;
  // opt.tooltip.triggerOn = 'none';
  // opt.tooltip.formatter = (params)=> {
  //   const flag = params.every(el=> el.value === undefined)
  //   if(flag) opt.tooltip.axisPointer.lineStyle.width = 0;
  // };
  // opt.xAxis.axisPointer.type = 'shadow'
  // opt.xAxis.axisPointer.triggerTooltip = true
  return opt;
};

export const chartConfig = (
  data: any,
  showItem: any,
  dealSeriesData,
  yAxis = '',
  // Studios charts use `date`; Portfolio Overview metrics use `label` (studio name).
  axisKey = 'date',
) => {
  const chartData: any = {};
  if (showItem.length === 0) return;
  showItem.map((item) => {
    if (item === 'table') {
      return;
    }
    const xAxisData: any = [];
    const datas: any = {};
    data.forEach((element: any) => {
      xAxisData.push(element[axisKey]);
      Object.keys(element).forEach((key) => {
        // Skip axis / tooltip identity fields so they are not treated as series metrics.
        if (
          key === axisKey
          || key === 'key'
          || key === 'label'
          || key === 'date'
          || key === 'title'
          || key === 'studio_id'
        ) {
          return;
        }
        if (datas[key]) {
          datas[key].push(element[key]);
        } else {
          datas[key] = [element[key]];
        }
      });
    });
    // xAxisData.push(''); // the reason of commenting this is we no longer need input dummy data at the end of our graph
    chartData[item] = {
      xAxisData,
      type: item,
      yAxis: yAxis,
      seriesData: dealSeriesData ? dealSeriesData(datas) : Object.values(datas),
    };
  });
  return chartData;
};

export type TValueAxisBoundaryGap = [string, string];

export const DEFAULT_VALUE_AXIS_BOUNDARY_GAP: TValueAxisBoundaryGap = [
  '2%',
  '2%',
];

/**
 * Expand value-axis min/max so bar / total labels are not clipped by the grid edge.
 * Prefer axis-scale padding over repositioning labels.
 *
 * When all data values are non-negative, explicitly sets `min: 0` to prevent
 * the percentage-based boundary gap from pushing the y-axis below zero.
 * (ECharts' `needCrossZero` safety check only fires when min is still positive
 * after the gap is applied — if the gap already pushed min negative, it's too late.)
 */
export const applyValueAxisBoundaryGap = (
  opt: any,
  boundaryGap: TValueAxisBoundaryGap = DEFAULT_VALUE_AXIS_BOUNDARY_GAP,
): void => {
  if (!opt?.yAxis) {
    return;
  }

  // Check if any series data value is negative.
  const allSeries = Array.isArray(opt.series) ? opt.series : [opt.series];
  const hasNegative = allSeries.some((series: any) => {
    if (!series?.data || !Array.isArray(series.data)) return false;
    return series.data.some((item: any) => {
      const val = typeof item === 'object' && item !== null ? item.value : item;
      return val !== null && val !== undefined && val !== '' && Number(val) < 0;
    });
  });

  const yAxes = Array.isArray(opt.yAxis) ? opt.yAxis : [opt.yAxis];
  yAxes.forEach((axis: any) => {
    if (axis?.type && axis.type !== 'value') {
      return;
    }
    axis.boundaryGap = boundaryGap;
    // Lock min to 0 when all data is non-negative so the boundary gap
    // can't push the y-axis below zero.
    if (!hasNegative && axis.min === undefined) {
      axis.min = 0;
    }
  });
};
